export default "__VITE_ASSET__CGKrkGNS__"